import { render, staticRenderFns } from "./WapMyCustomerService.vue?vue&type=template&id=8f7e2b84&"
import script from "./WapMyCustomerService.vue?vue&type=script&lang=js&"
export * from "./WapMyCustomerService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports